import React from "react";
import { sortableElement, sortableHandle } from "react-sortable-hoc";
import IconComponent from "components/IconComponent";
import { DragIcon } from "icons";

const DragHandle = sortableHandle(() => (
  <IconComponent
    Component={DragIcon}
    onHoverColor="#26BBED"
  />
));

const SortableItem = sortableElement(({ classes, id, children, ...props }) => (
  <div draggable="true" id={id} className={classes.listItemContainer}>
    <DragHandle classes={classes} />
    <div>{children}</div>
  </div>
));

export default SortableItem;
